import { render, staticRenderFns } from "./ItemCareer.vue?vue&type=template&id=21827321&scoped=true&"
import script from "./ItemCareer.vue?vue&type=script&lang=js&"
export * from "./ItemCareer.vue?vue&type=script&lang=js&"
import style0 from "./ItemCareer.vue?vue&type=style&index=0&id=21827321&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21827321",
  null
  
)

export default component.exports